<template>
    <Banner>
        <BannerCollectionDescription
            :description="collection.description"
            :title="collection.title"
            :collectionId="collection.id"
            :categories="collection.categoriesWithAncestors"
            :levels="collection.levels"
            :publishDate="collection.publishDate"
            :expirationDate="collection.expirationDate"
            :lastUpdatedDate="collection.checkedAt"
        >
        </BannerCollectionDescription>

        <BannerCollectionDetails
            :duration="duration"
            :amountOfCourses="courses.length"
            :showFinishProgress="showFinishProgress"
            :finishProgress="totalCompletedInCollection"
        >
        </BannerCollectionDetails>
    </Banner>
</template>

<script>
    import Banner from 'components/layout/Banner'
    import BannerCollectionDescription from './BannerCollectionDescription'
    import BannerCollectionDetails from './BannerCollectionDetails'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            Banner,
            BannerCollectionDetails,
            BannerCollectionDescription
        },
        props: {
            collection: Object,
            courses: Array,
            finishProgress: {
                type: Number,
                default: 0
            },
            showFinishProgress: {
                type: Boolean,
                default: false
            },
            duration: Number
        },
        computed: {
            ...mapGetters({
                isCourseCompleted: 'CompletedCourses/isCourseCompleted'
            }),
            totalCompletedInCollection () {
                let completedInCollection = this.courses.filter(course => this.isCourseCompleted(course.id))
                if (completedInCollection.length === 0) {
                    return 0
                }
                return Math.round(completedInCollection.length / this.courses.length * 100)
            }
        }
    }
</script>
